<template>
  <div class="confectionModal">
    <div class="confectionModal-top">
      <img
        class="confectionModal-image img-responsive"
        alt="envelope example"
        :src="image"
        width="350px"
      >
    </div>

    <div class="confectionModal-content">
      <h2 class="confectionModal-title">Etui na kupony z etykietami</h2>
      <section class="confectionModal-descriptions">
        <p>Eleganckie etui nada prezentowi jeszcze bardziej <strong>prestiżowy wygląd i indywidualny charakter!</strong></p>
      </section>
      <section>
        <p>Na etui mogą zostać nadrukowane takie informacje jak imię, nazwisko, przekazana kwota.</p>
        <p>
          <a :href="file" target="_blank" class="text-underline">Pobierz szablon</a>
          , aby uzupełnić dane, które zostaną nadrukowane na etui. Plik będziesz mógł załączyć w kroku „DOSTAWA”.
        </p>
      </section>
      <section class="confectionModal-warnings">
        <p>
          UWAGA! Przed wysłaniem sprawdź, czy liczba zamawianych etui jest zgodna z liczbą rekordów w pliku excel.
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'etuiCouponModal',
  props: {
    image: {
      type: String,
      required: true,
    },
    file: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
